import { render } from "./InscriptionThead.vue?vue&type=template&id=2deaf7fb&scoped=true"
import script from "./InscriptionThead.vue?vue&type=script&lang=js"
export * from "./InscriptionThead.vue?vue&type=script&lang=js"

import "./InscriptionThead.vue?vue&type=style&index=0&id=2deaf7fb&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2deaf7fb"]])

export default __exports__